import { IExtendedEvent } from '@wix/social-groups-serverless/dist/events/types';

export function getScheduleTbdMessage(event: IExtendedEvent) {
  return event.dateAndTimeSettings?.dateAndTimeTbd;
}
